import Vue from 'vue'

import {
    forEach as _forEach,
    orderBy as _orderBy,
} from 'lodash'

import CarModel from '@/models/CarModel'

import carService from '@/services/car.service'

// -----------------------------------------------------------------------------

const state = {
    isLoading: false,
    isSaving: false,
    isDeleting: false,
    cars: {},
}

const getters = {
    getCars: state => {
        return _orderBy(state.cars, ['id'], ['asc'])
    },

    getCar: state => carId => {
        return state.cars[carId] || null
    },
}

const mutations = {
    setLoading(state, isLoading) {
        state.isLoading = !!isLoading
    },

    setSaving(state, isSaving) {
        state.isSaving = !!isSaving
    },

    setDeleting(state, isDeleting) {
        state.isDeleting = !!isDeleting
    },

    setCars(state, payload) {
        state.cars = {}

        _forEach(payload, item => {
            const Car = new CarModel(item)

            Vue.set(state.cars, Car.id, Car)
        })
    },

    setCar(state, payload) {
        const Car = new CarModel(payload)

        Vue.set(state.cars, Car.id, Car)
    },
}

const actions = {
    async fetch({ commit }) {
        commit('setLoading', true)

        let response

        try {
            response = await carService.getClientCars()

            commit('setCars', response.response.items)
            commit('setLoading', false)
        } catch (error) {
            commit('setLoading', false)
            return Promise.reject(error)
        }
    },

    async createCar({ commit }, params) {
        commit('setSaving', true)

        try {
            await carService.createClientCar(params)

            commit('setSaving', false)
        } catch (error) {
            commit('setSaving', false)
            return Promise.reject(error)
        }
    },

    async updateCar({ commit }, params) {
        commit('setSaving', true)

        try {
            await carService.updateClientCar(params)

            commit('setSaving', false)
        } catch (error) {
            commit('setSaving', false)
            return Promise.reject(error)
        }
    },

    async deleteCar({ commit }, params) {
        commit('setDeleting', true)

        try {
            await carService.deleteClientCar(params)

            commit('setDeleting', false)
        } catch (error) {
            commit('setDeleting', false)
            return Promise.reject(error)
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
